import React, { useState } from "react";
import { useGetTotalCountQuery } from "../../../redux/api/SummaruData";
import { useGetSummaryDataQuery } from "../../../redux/api/SummaruData";
import { HeaderSide } from "./headerside";
import { CountGraph } from "./CountGraph";
import { SummaruTable } from "./summaruTable";
import { Input, Pagination, Button } from "antd";
import SelectTerritorialUnitsCode from "../../selects/SelectTerritorialUnitsCode";
import SelectYear from "../../selects/SelectYear";
import { PreloaderSvg } from "../../preloaderSvg/PreloaderSvg";

export const SummaryData = () => {
  const [filters, setFilters] = useState({
    page: 1,
    size: 10,
    regionalUnitId: null as number | null,
    areaUnitId: null as number | null,
    farmerFullName: "",
    createdYear: null as number | null,
  });

  const [selectedRegionId, setSelectedRegionId] = useState<number | null>(null);

  const { data: totalCount, isLoading: totalCountLoading } =
    useGetTotalCountQuery({});

  const { data: summaryData, isLoading: summaryDataLoading } =
    useGetSummaryDataQuery(filters);


  const handleRegionalUnitChange = (value: number | string, option?: any) => {
    const numericValue = typeof value === 'string' ? parseInt(value) : value;
    setSelectedRegionId(numericValue || null);
    setFilters(prev => ({ ...prev, regionalUnitId: numericValue || null, areaUnitId: null, page: 1 }));
  };

  const handleAreaUnitChange = (value: number | string, option?: any) => {
    const numericValue = typeof value === 'string' ? parseInt(value) : value;
    setFilters(prev => ({ ...prev, areaUnitId: numericValue || null, page: 1 }));
  };

  const handleYearChange = (value: number | null) => {
    setFilters(prev => ({ ...prev, createdYear: value, page: 1 }));
  };

  const handleFarmerNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFilters(prev => ({ ...prev, farmerFullName: e.target.value, page: 1 }));
  };

  const handlePageChange = (page: number) => {
    setFilters(prev => ({ ...prev, page }));
  };

  const handleClearFilters = () => {
    setSelectedRegionId(null);
    setFilters({
      page: 1,
      size: 10,
      regionalUnitId: null,
      areaUnitId: null,
      farmerFullName: "",
      createdYear: null,
    });
  };

  const hasActiveFilters =
    filters.regionalUnitId !== null ||
    filters.areaUnitId !== null ||
    filters.farmerFullName.trim() !== "" ||
    filters.createdYear !== null;

  if (summaryDataLoading || totalCountLoading) {
    return <div><PreloaderSvg /></div>;
  }
  return (
    <div>
      <HeaderSide />
      <CountGraph
        data={totalCount?.res ?? {}}
        isLoading={totalCountLoading}
      />

      <div style={{ padding: "20px", background: "#f5f5f5", }}>
        <div style={{ display: "flex", gap: "16px", alignItems: "center", flexWrap: "wrap" }}>
        <div >
            <SelectYear
              value={filters.createdYear}
              onChange={handleYearChange}
              placeholder="2025"
            />
          </div>
          <div style={{ minWidth: "200px" }}>
            <SelectTerritorialUnitsCode
              type={["REGION", "CITY_OF_REPUBLICAN_SIGNIFICANCE"]}
              value={filters.regionalUnitId}
              onChange={handleRegionalUnitChange}
              placeholder="Область"
            />
          </div>
          {selectedRegionId && (
            <div style={{ minWidth: "200px" }}>
              <SelectTerritorialUnitsCode
                type={["AREA"]}
                parentId={selectedRegionId}
                value={filters.areaUnitId}
                onChange={handleAreaUnitChange}
                placeholder="Район"
              />
            </div>
          )}
          {/* <div style={{ minWidth: "200px" }}> */}

            {/* <Input
              value={filters.farmerFullName}
              onChange={handleFarmerNameChange}
              placeholder="Введите ФИО фермера"
              style={{ width: "100%" }}
            /> */}
          {/* </div> */}

          {hasActiveFilters && (
            <div style={{ display: "flex", alignItems: "end" }}>
              <Button
                type="default"
                onClick={handleClearFilters}
                style={{
                  height: "32px",
                  backgroundColor: "#ff4d4f",
                  borderColor: "#ff4d4f",
                  color: "#fff",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = "#ff7875";
                  e.currentTarget.style.borderColor = "#ff7875";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = "#ff4d4f";
                  e.currentTarget.style.borderColor = "#ff4d4f";
                }}
              >
                Сбросить фильтр
              </Button>
            </div>
          )}
        </div>
      </div>
 
      <SummaruTable
        data={summaryData?.res ?? {}}
        isLoading={summaryDataLoading}
      />

      {summaryData?.res && summaryData.res.totalElements > 0 && (
        <div style={{
          display: "flex",
          justifyContent: "flex-end",
          marginTop: "24px",
          marginBottom: "24px",
          paddingRight: "16px"
        }}>
          <Pagination
            current={filters.page}
            total={summaryData.res.totalElements}
            pageSize={filters.size}
            onChange={handlePageChange}
            showSizeChanger={false}
          />
        </div>
      )}
    </div>
  );
};

    